function toEnglishNumber(num) {
  if (num) {
    let persianNumbers = [
      /۰/g,
      /۱/g,
      /۲/g,
      /۳/g,
      /۴/g,
      /۵/g,
      /۶/g,
      /۷/g,
      /۸/g,
      /۹/g,
    ];
    num = num.toString();
    for (var i = 0; i < 10; i++) {
      num = num.replace(persianNumbers[i], i);
    }
    return num;
  } else {
    return num;
  }
}
export default toEnglishNumber;
